// extracted by mini-css-extract-plugin
export default {"mainCon":"Panel_mainCon__Y9NJR","header":"Panel_header__xUMcp","heading":"Panel_heading__3+dvH","dropdownIcon":"Panel_dropdownIcon__nQm8L","children":"Panel_children__dkWGK"};